import { useNavigate, useLocation } from 'react-router-dom';
const useBack = () => {
    const navigate = useNavigate();
    const location = useLocation();
    return (url) => navigate(location.state?.from || url);
};
export default useBack;
